import { createUseTranslation } from "core/session/translation";

export const useAutocompleteInputTranslation = createUseTranslation({
  en: {
    loadingOptions: "Loading...",
    placeholder: "Enter value",
  },
});
